import {
  Routes as Switch,
  Route,
  useMatch as useRouteMatch,
  Navigate as Redirect,
  Outlet
} from 'react-router-dom';
import Home from './main';
import { Body } from 'components/reportBody';
import BodyCompiler from 'components/reportBody/newReportCompiler';
import { AggiornamentiTable } from 'components/aggiornamentiTable';
const HomeIndex = () => {
  const path = '';
  return (
    <Switch>
      <Route exact path={path} element={<Home />} />
      {/*<Route exact path={`${path}/link`} element={<BodyCompiler mainTitle={'Link'} />} />*/}
      <Route exact path={`${path}/link`} element={<BodyCompiler />} />
      <Route exact path={`${path}/in-evidenza`} element={<BodyCompiler mainTitle={'In Evidenza'} />} />
      <Route exact path={`${path}/piu-consultati`} element={<BodyCompiler mainTitle={'I più consultati'} />} />
      <Route
        exact
        path={`${path}/aggiornamenti`}
        element={<AggiornamentiTable mainTitle={'Aggiornamenti'} />}
      />
      <Route path={`${path}/*`} exact={true} element={<Redirect to="/home" />} />
    </Switch>
  );
};

export default HomeIndex;
